"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobSearchQuerySchema = exports.JobIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
exports.JobIdPathParamsSchema = zod_1.z.object({ jobId: schemas_1.UUIDSchema });
exports.JobSearchQuerySchema = zod_1.z.object({}).merge(schemas_1.PaginationQuerySchema);
